import React from "react";

function ViewSupplier({ data }) {
  return (
      <div className="card-body">
      <div className="row">
         <div className="col-md-6 mb-3">
              <label>Vendor Name</label>
              <input
                type="text"
                className="form-control"
                value={data?.vendor_details.name ||data?.vendor_details.mobile|| "-"}
                disabled
              />
            </div>
     <div className="col-md-6 mb-3">
          <label>Supplier Name</label>
          <input
            type="text"
            className="form-control"
            value={data?.supplier_name || "-"}
            disabled
          />
        </div>
     <div className="col-md-6 mb-3">
          <label>Company Name</label>
          <input
            type="text"
            className="form-control"
            value={data?.company_name || "-"}
            disabled
          />
        </div>
     <div className="col-md-6 mb-3">
          <label>Email</label>
          <input
            type="text"
            className="form-control"
            value={data?.email || "-"}
            disabled
          />
        </div>
     <div className="col-md-6 mb-3">
          <label>Mobile Number</label>
          <input
            type="text"
            className="form-control"
            value={data?.mobile_number || "-"}
            disabled
          />
        </div>
     <div className="col-md-6 mb-3">
          <label>GST</label>
          <input
            type="text"
            className="form-control"
            value={data?.gst_number || "-"}
            disabled
          />
        </div>
     <div className="col-md-6 mb-3">
          <label>State</label>
          <input
            type="text"
            className="form-control"
            value={data?.state || "-"}
            disabled
          />
        </div>
     <div className="col-md-6 mb-3">
          <label>City</label>
          <input
            type="text"
            className="form-control"
            value={data?.city || "-"}
            disabled
          />
        </div>
     
     <div className="col-md-6 mb-3">
          <label>PinCode</label>
          <input
            type="text"
            className="form-control"
            value={data?.pincode || "-"}
            disabled
          />
        </div>
     <div className="col-md-6 mb-3">
          <label>Address</label>
          <input
            type="text"
            className="form-control"
            value={data?.address || "-"}
            disabled
          />
        </div>
     <div className="col-md-6 mb-3">
          <label>Status</label>
          <input
            type="text"
            className="form-control"
            value={data?.status === 1 ? " Active" : " Inactive"}
            disabled
          />
        </div>
     

    </div>
    </div>
  );
}

export default ViewSupplier;